import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    "translation": {
        "title": "Data Breach at {{store}}: Customer Data Security",
        "greeting": "Dear Customers,",
        "description": "At {{store}}, we take the security of your data very seriously. We want to inform you about a recent data breach in our system.",
        "whatHappened": "1. What happened?",
        "whatHappenedDesc": "Recently, a data breach was reported due to cybercrime, exposing customer data. Unauthorized access was gained to certain customer information, but no sensitive data such as passwords or financial information was accessed.",
        "leakedData": "2. What data was leaked?",
        "leakedDataDesc" : "No passwords, payment details or other sensitive information was accessed.",
        "leakedData1": "Name",
        "leakedData2": "Email Address",
        "leakedData3": "Billing Address (for orders)",
        "leakedData4": "Shipping Address (for orders)",
        "actionsTaken": "3. What actions have we taken?",
        "actionsTakenDesc": "After the incident, we immediately reported the data breach to the Dutch Data Protection Authority (AP) and sent an email to the affected customers. In addition, we tightened our internal processes, fixed vulnerabilities and took additional security measures to reduce the chance of recurrence.",
        "recommendations": "4. Recommendations for affected customers",
        "recommendationsDesc": "If you believe your data may have been compromised, we advise you to be extra vigilant for phishing emails or other scams. Do not click on unknown links or share sensitive information if you are unsure about the sender.",
        "recommendationsDesc2" : "At Promofit, we remain committed to protecting your data. If you have any questions or require further information, please do not hesitate to contact us.",
        "closing": "Best regards,",
        "team": "The {{store}} Team",
        "recentViewed": "Recently view",
        "FeaturedProducts" : "Featured Products",
        "Bestellen" : "Order",
        "homepage": "homepage",
        "showmorearticles":"show more articles",
        "viewall": "view all",
        "from": "from",
        "lookat": "look at",
        "Readmore":"Read more",
        "Viewproducts": "View products",
        "Moreinfo" : "More info",
        "Readallreviews":"Read all reviews",
        "Blogarticles" : "Blog articles",
        "Whatareyoulookingfor" : "What are you looking for?",
        "resultsfound": "results found" ,
        "Showallresults" : "Show all results",
        "volgende" : "next",
        "Klik op volgende om door te gaan" : "Click next to continue",
        "Kies een kleur om verder te gaan" : "Choose a color to continue",
        "Kieseenoptie" : "Choose an option",
        "nietopvoorraad" : "out of stock",
        "voorraad_info" : "stock info",
        "stuks" : "pieces",
        "stuk" : "piece",
        "Tooltip" : "Tooltip",
        "voorraad" : "stock",
        "nietop" : "Out of",
        "Indien mogelijk kunt u maximaal 3 kleursamples tegelijk aanvragen (één item per kleur)" : "If possible, you can request a maximum of 3 color samples at a time (one item per color)",
        "Prijstabel": "Price table",
        "MultipleSizesOrder": "Meerdere maten bestellen is mogelijk. Het totaal van deze maten dient minimaal {{minQty}} stuks te zijn.",
        "Minimumorderqty" : "The minimum order quantity has not yet been reached.",
        "Dimensions" : "Dimensions",
        "Quantity" : "Quantity",
        "Totalquantity" : "Total quantity:",
        "Color" : "Color",
        "Kieseenkleur" : "Choose a color",
        "Voegeenkleurtoe" : "+ Add a color",
        "toonmeer" : "show more" ,
        "toonminder" : "show less",
        "Vraagsampleaan" : "Request sample",
        "GratisVoorbeeld": "Always a <strong>free digital preview</strong> in advance:",
        "Upload uw drukbestand": "-Upload your print file(s)",
        "Leesminder" : "Read less",
        "Leesmeer" : "Read more",
        "UploadDrukbestand" : "Simply upload your print file(s) or submit them after ordering",
        "OnlineDesigner" : "- Or design yourself with the Online Designer",
        "LeverOntwerpLater" : "I will deliver the design later",
        "Uwbestanden:" : "Your files:",
        "Ontwerponline" : "Design online",
        "Anderaantal" : "Other quantity",
        "Aantal" : "Quantity",
        "Bespaar" : "Save",
        "Stuksprijs" : "Unit price" ,
        "Totaalprijs" : "Total price",
        "Dezevindjemisschienookleuk" : "You might also like these",
        "Deelartikel" : "Share article",
        "Geschrevendoor" : "Written by",
        "door" : "by",
        "Laadmeerartikelen" : 'Load more articles',
        "Bestand(en):" : "File(s):",
        "MiniBestand(en)" : "File(s):",
        "Winkelwagen" : "Shopping cart",
        "Uw winkelwagen is leeg" : "Your shopping cart is empty.",
        "om naar de homepage te gaan" : "to go to the homepage",
        "Digitale drukproef" : "Digital proof",
        "Gratis" : "Free" ,
        "Instelkosten" : "Set-up costs",
        "Kortingscode" : "Discount code",
        "Totaal (excl. BTW)" : "Total (excl. VAT)",
        "BTW" : "VAT",
        "Totaalbedrag": "Total amount",
        "Vrijblijvende offerte" : "Free quote",
        "Verberg prijsdetails" : "Hide price details",
        "Bekijk prijsdetails" : "View price details",
        "We hebben voor u gezocht op" : "We searched for you on" ,
        "wis filters" : "clear filter",
        "Categorieën" : "Categories",
        "Sorteren" : "Sort",
        "Filters" : "Filters",
        "sorteer op:" : "sort by:",
        "artikelen" : "articles",
        "filter en sorteer" : "filter and sort",
        "Bekijk meer" : "View more",
        "Uw zoekopdracht heeft geen resultaten opgeleverd" : "Your search returned no results." ,
        "Hallo, waarmee kunnen we je helpen" : "Hello, how can we help you?",
        "Kan ik een sample ontvangen" : "Can I receive a sample?",
        "Wat is de levertijd" : "What is the delivery time?",
        "Telefoon" : "Phone",
        "TelefoonBelgie" : "Phone Belgium" ,
        "E-mail" : "Email" ,
        "Openingstijden" : "Opening hours" ,
        "Deeluwconfiguratiemetuniekelink" : "Share your configuration with unique link",
        "Toevoegen in favorieten" : "Add to favorites",
        "Bewaard in favorieten" : "Saved to favorites",
        "Zie winkelwagen" : "See shopping cart" , 
        "Verzendkosten" : "Postage costs" , 
        "Maatwisselkosten" : "Size change costs" ,
        "Prijs per stuk" : "Price per piece",
        "per stuk" : "per piece",
        "Sample prijs" : "Sample price",
        "Verstuurd na" : "Sent after:",
        "Totaal incl. BTW" : "Total incl. VAT",
        "Totaal excl. BTW" : "Total excl. VAT",
        "Neem contact op" : "Contact Us",
        "contact_description" : "Do you have any questions, comments or suggestions? Please let us know via the contact form below. Or feel free to contact us by phone, email or Whatsapp",
        "verplicht_veld" : "* required field",
        "Bezoekadres" : "Visiting address",
        "Bedrijfsgegevens" : "Company details",
        "Gesloteni.v.m.feestdagen" : "Closed for holidays",
        "KvK nummer:": "Chamber of Commerce number:",
        "BTW nummer:": "VAT number:",
        "Druktechnieken": "Printing Techniques",
        "Meestgesteldevragen" : "Frequently Asked Questions",
        "Klantenservice": "Customer Service",
        "Schrijfalseersteeenreview" : "Be the first to write a review",
        "Vacatures" : "Vacancies" , 
        "Afdeling" : "Department",
        "Bekijken" : "To look at",
        "Er zijn momenteel geen vacatures beschikbaar" : "There are currently no vacancies available.",
        "Kortingscodes" : "Discount codes" ,
        "Korting_desc" : "An overview of discount codes and promotional codes at Promofit can be found below.The codes are valid once on a new online order or quote request, not retroactively valid on current orders/requests. Keep an eye on this page to stay informed of new promotional codes. Subscribe to our newsletter or follow us on our socials for more discount codes!",
        "Korting_subdesc" : "The discount codes do not apply to VAT, shipping costs or in combination with other promotions, unless stated.",
        "Korting" : "Discount" , 
        "Code" : "Code" , 
        "Voorwaarden" : "Terms and Conditions",
        "Geldigheid" : "Validity",
        "Actief" : "Active",
        "Verlopen" : "Expired",
        "Kiyohklantbeoordelingen" : "Kiyoh customer reviews",
        "Heeft u al een account bij" : "Do you already have an account at",
        "Log dan hier in" : "Log in here:",
        "Wachtwoordvergeten" : "Forgot your password?",
        "Account_desc" : "Creating an account is not necessary to order, but it is useful",
        "Nieuwbij" : "New to",
        "Maak account aan" : "Create account",
        "Inloggen" : "Login",
        "forgot_desc" : "Enter your email address below. We will then send you a link so that you can set a new password. This may take a while, also check your spam folder.",
        "Jewachtwoordvergeten" : "Forgot your password?",
        "Terug" : "Back",
        "Account aanmaken" : "Create an account",
        "Hallo" : "Hello" , 
        "leuk dat je er weer bent" : "Nice to see you again!" ,
        "Hier vind je de status van je bestellingen" : "Here you can find the status of your orders" , 
        "Address_desc" : "You can also change your password, add addresses and change your newsletter subscription",
        "artikel(en)" : "article(s)",
        "Wijzigen" : "Change",
        "Nieuwsbrief" : "Newsletter",
        "Mijn gegevens" : "My details",
        "Bedrijfsnaam" : "Company name",
        "Voornaam" : "First name",
        "Achternaam" : "Last name" , 
        "Telefoonnummer" : "Phone number",
        "Type klant" : "Customer type",
        "Wachtwoord" : "Password",
        "Annuleren" : "Cancel",
        "Geenselectie" : "No selection",
        "order_question" : "Do you have any questions about your order? Please send an email to",
        "call_us" : "or call us at",
        "Via_the_website" : "Via the website",
        "Online_bestelling" : "Online order:",
        "bekijk_details" : "view details",
        "receive_update" : "Receive updates on new products, offers and discount codes via our newsletter.",
        "subscription" : "Manage your subscription below. You will receive the newsletter for the box that is checked." ,
        "privacy_policy" : "Read our privacy policy to find out how we handle your personal data. You can always unsubscribe via the unsubscribe link in the newsletter.",
        "Opslaan" : "Save",
        "Opnieuw_bestellen" : "Reorder",
        "Sample_bestelling" : "Sample Order",
        "Offerteaanvraag" : "Quote Request",
        "Betaalmethode" : "Payment Method",
        "Factuur" : "Invoice" , 
        "Uw gegevens" : "Your Details" , 
        "Factuuradres" : "Billing Address",
        "Verwachte_verzenddatum" : "Expected Shipping Date:",
        "Verberg_details" : "Hide details" ,
        "Address_desc_overview" : "Addresses that are changed are unfortunately NOT automatically processed in current orders. Please also pass on the address change to the sales employee.",
        "Adresboek" : "Address book",
        "Standaard factuuradres" : "Standard billing address" ,
        "Er is nog geen standaard factuuradres" : "There is no standard billing address yet.",
        "Toevoegen" : "Add" ,
        "Standaard afleveradres" : "Standard delivery address" ,
        "Er is nog geen standaard leveradres" : "There is no standard delivery address yet.",
        "Addnew_address" : "+ Add new address",
        "zipcode" : "zipcode",
        "Bekijk_alle_review" : "View all review",
        "Solliciteer_direct" : "Apply now",
        "Deel_deze_vacature" : "Share this vacancy",
        "terug_naar_vacatures" : "back to vacancies",
        "Schrijf_een_review_voor" : "Write a review for" ,
        "Review_desc" : "We check every submitted product review. After approval, your review will appear on the product page.",
        "Sample_bestellen" : "Order sample",
        "Uw_winkelwagen_is_leeg" : "Your shopping cart is empty.",
        "Klik_hier" : "Click here",
        "om_naar_de_homepage_te_gaan" : "to go to the homepage",
        "Vrijblijvende_offerte_aanvraag" : "Request a no-obligation quote",
        "Offerte_aanvragen" : "Request a quote",
        "Bedankt_voor_je_bestelling" : "Thank you for your order,",
        "Bedankt_voor_je_offerteaanvraag" : "Thank you for your quote request,",
        "Offertenummer" : "Quote number",
        "De_bevestiging_wordt_verstuurd_naar" : "The confirmation will be sent to",
        "Mail_desc" : "Also check your spam folder! Didn't receive anything? Contact us via",
        "Bekijk_offerte_in_mijn_account" : "View quote in my account",
        "verder_winkelen" : "Continue shopping",
        "Vrijblijvende_offerte" : "Free quote",
        "order_confirm" : "The order confirmation will be sent to your email address.",
        "Bekijk_bestelling_in_mijn_account" : "View order in my account",
        "Ordernummer" : "Order number" ,
        "Besteloverzicht" : "Order overview",
        "Afrekenen" : "To settle",
        "Naar_verzending" : "To shipping",
        "Verzending" : "Dispatch",
        "Bestelling_afronden" : "Complete order",
        "Adres_toevoegen" : "+ Add address",
        "Afleveradres" : "Delivery address",
        "login_with_details_desc" : "You already have an account with us, log in with your details.",
         "checkout_desc" : "Please note: the shipping address will not be used for pick-up. Your order can be picked up at: Pauvreweg 22, 4879 NA Etten-Leur." ,
         "Naar_afronden" : "To rounding off",
         "Paylater_desc" : "In case of printed items, you will receive the invoice by email after approval of artwork. For unprinted items, you will receive the invoice by email after processing the order. Your order will be shipped after full payment has been made.",
         "Mondu_desc" : "After delivery of your order, you will receive the invoice by e-mail and must pay the invoice amount within 30 days. Information about the processing of your personal data by Mondu GmbH can be found",
         "hier" : "here",
         "Paylater_lable" : "Complete order without paying immediately",
         "Nieuwe_voorraad_onderweg" : "New Stock On The Way",
         "Huidige_voorraad" : "Current Stock",
         "Geef_de_gewenste_afmeting_op": "Please specify the desired size",
         "Faq_placeholder" : "Can I receive a sample/trial model?",
         "Faq_delivery" : "What is the delivery time?" ,
         "vieweverything" : "View everything",
         "Verzonden_op" : "Sent on:",
         "mijn-bestellingen" : "my-orders",
         "mijn-offertes" : "my-quotes",
         "Verwijderen" : "Remove",
         "payment_error" : "Please select a payment method to continue",
         "Mijn_accountoverzicht" : "My account overview",
         "login" : "login",
         "Gekopieerd" : "Copied",
         "Kopieer_link" : "Copy link",
         "Artikelnummer" : "Article number",
         "Schrijf_een_review" : "Write a review",
         "Bekijk_alle_reviews" : "View all reviews",
         "Populair" : "Popular",
        "Onze keuze!" : "Our choice!",
        "Custom made" : "Custom made",
        "van" : "by",
        "en betalingen" : "and payments.",
        "terug naar" : "back to",
        "bestellingen" : "orders",
        "offerteaanvragen": "quotation requests",
        "stapsgewijze hoeveelheid door" : "step by step amount by",
        "Minimum bestelgrootte" : "Minimum order size",
        "Eerst het product testen? Vraag een sample aan!" : "Want to test the product first? Request a sample!",
        "Ervaar onze" : "Experience our",
        "snelle topservice!" : "fast top service!",
        "High level service" : "High level service",
        "met een vast contact persoon" : "with a permanent contact person",
        "Laagste prijsgarantie" : "Lowest price guarantee",
        "elders goedkoper? Wij matchen!" : "Cheaper elsewhere? We match!",
        "Beste prijs-kwaliteitverhouding" : "Best value for money",
        "Gratis digitaal voorbeeld" : "Free digital sample",
        "binnen enkele uren in uw e-mail!" : "in your email within hours!",
        "Eigen productie" : "Own production",
        "dus snel geleverd" : "so delivered quickly",
        "Veilig betalen" : "Secure payment",
        "o.a. iDeal, Bancontact, ook achteraf!" : "including iDeal, Bancontact, also afterwards!",
        "searchplaceholder" : "What are you looking for?",
        "op_nacalculatie" : "on post-calculation *",
        "Totaalprijs bij" : "Total price at",
         "incl. BTW" : "incl. VAT",
         "Achternaam*" : "Last name *",
         "Voornaam*" : "First name *",
         "Bedrijfsnaam*" : "Company name *",
         "E-mail_adres*" : "Email address *",
         "E-mail_adres" : "Email address",
         "Bevestig_wachtwoord" : "Confirm password",
         "Bevestig_wachtwoord*" : "Confirm password *",
         "Wachtwoord*" : "Password *",
         "max_samples_1": "You can max",
         "max_samples_2": "request samples at once, if available.",
         "Huisnummer*": "House number *",
         "Onbedrukt_niet_mogelijk" : "Unprinted not possible",
          //use case
         "cartPage_tooltip_quoteMessage" : `This article comes from a quote; therefore, you cannot change the quantity directly. Would you still like to order a different quantity? Please feel free to request a new quote.`,
          "address_tooltip_edit_delete" : `It is currently not possible to edit or delete this address as it is linked to an active quote.`,
          "price_overview" : `Price overview`
    }
  },
  nl: {
    "translation": {
    "title": "Datalek bij {{store}}: Beveiliging van klantgegevens",
    "greeting": "Beste klanten,",
    "description": "Bij {{store}} nemen wij de beveiliging van uw gegevens uiterst serieus. We willen u informeren over een recent datalek dat heeft plaatsgevonden in ons systeem.",
    "whatHappened": "1. Wat is er gebeurd?",
    "whatHappenedDesc": "Onlangs werd er een datalek gemeld door cybercriminaliteit, waarbij klantgegevens mogelijk zijn blootgesteld. Er is onrechtmatige toegang geweest tot bepaalde klantgegevens, maar er is geen toegang verkregen tot gevoelige informatie zoals wachtwoorden of financiële gegevens.",
    "leakedData": "2. Welke gegevens zijn gelekt?",
    "leakedDataDesc" : "Er is geen toegang verkregen tot wachtwoorden, betalingsgegevens of andere gevoelige informatie.",
    "leakedData1": "Naam",
    "leakedData2": "E-mailadres",
    "leakedData3": "Factuuradres (alleen bij bestellingen)",
    "leakedData4": "Leveradres (alleen bij bestellingen)",
    "actionsTaken": "3. Wat hebben we ondernomen?",
    "actionsTakenDesc": "Na het incident hebben we onmiddellijk het datalek gemeld bij de Autoriteit Persoonsgegevens (AP) en een e-mail verstuurd naar de getroffen klanten. Daarnaast hebben we onze interne processen aangescherpt, kwetsbaarheden verholpen en extra beveiligingsmaatregelen genomen om de kans op herhaling te verkleinen.",
    "recommendationsDesc2" : "Bij Promofit blijven we ons inzetten voor de bescherming van uw gegevens. Mocht u vragen hebben of meer informatie wensen, neem dan gerust contact met ons op.",
    "recommendations": "4. Aanbevelingen voor getroffen klanten",
    "recommendationsDesc": "Als u denkt dat uw gegevens mogelijk zijn getroffen, raden wij u aan extra waakzaam te zijn voor phishing-e-mails of andere vormen van oplichting. Klik niet op onbekende links en deel geen gevoelige informatie als u twijfelt over de afzender.",
    "closing": "Met vriendelijke groet,",
    "team": "Het {{store}}-team",
    "recentViewed": "Recent bekeken",
    "FeaturedProducts" : "Uitgelichte producten",
    "Bestellen" : "Bestellen",
    "homepage":"startpagina",
    "showmorearticles": "toon meer artikelen",
    "viewall": "bekijk alle",
    "vieweverything" : "bekijk alles",
    "from":"vanaf",
    "lookat": "bekijk",
    "Readmore":"Lees meer",
    "Viewproducts": "Bekijk producten",
    "Moreinfo" : "Meer info",
    "Readallreviews":"Lees alle beoordelingen",
    "Blogarticles" : "Blogartikelen",
    "Whatareyoulookingfor" : "Waar bent u naar op zoek?",
    "resultsfound": "resultaten gevonden" ,
    "Showallresults" : "Toon alle resultaten",
    "volgende" : "volgende",
    "Klik op volgende om door te gaan" : "Klik op volgende om door te gaan",
    "Kies een kleur om verder te gaan" : "Kies een kleur om verder te gaan",
    "Kieseenoptie": "Kies een optie",
    "nietopvoorraad" : "niet op voorraad",
    "stuks": "stuks",
    "stuk" : "stuk",
    "Tooltip" : "Tooltip",
    "voorraad" : "voorraad",
    "nietop" : "niet op",
    "voorraad_info" : "voorraad info",
    "Nieuwe_voorraad_onderweg" : "Nieuwe voorraad onderweg",
    "Indien mogelijk kunt u maximaal 3 kleursamples tegelijk aanvragen (één item per kleur)" : "Indien mogelijk kunt u maximaal 3 kleursamples tegelijk aanvragen (één item per kleur)",
    "Prijstabel": "Prijstabel",
    "MultipleSizesOrder": "Meerdere maten bestellen is mogelijk. Het totaal van deze maten dient minimaal {{minQty}} stuks te zijn.",
    "Minimumorderqty" : "De minimale bestelhoeveelheid is nog niet bereikt.",
    "Dimensions" : "Afmeting",
    "Quantity" : "Aantal",
    "Totalquantity" : "Totaal aantal:",
    "Color" : "Kleur",
    "Kieseenkleur" : "Kies een kleur",
    "Voegeenkleurtoe" : "+ Voeg een kleur toe",
    "toonmeer" : "toon meer",
    "toonminder" : "toon minder",
    "Vraagsampleaan" : "Vraag sample aan",
    "GratisVoorbeeld": "Altijd een <strong>gratis digitaal voorbeeld</strong> vooraf:",
    "Upload uw drukbestand" : "-Upload uw drukbestand(en)",
    "Leesminder" : "Lees minder",
    "Leesmeer" : "Lees meer",
    "UploadDrukbestand" : "Upload eenvoudig uw drukbestand(en) of lever deze aan na de bestelling.",
    "OnlineDesigner" : "- Of ontwerp zelf met de Online Designer",
    "LeverOntwerpLater" : "Ik lever het ontwerp later aan",
    "Uwbestanden" : "Uw bestanden:",
    "Ontwerponline" : "Ontwerp online",
    "Anderaantal" : "Ander aantal",
    "Aantal" : "Aantal",
    "Bespaar" : "Bespaar",
    "Stuksprijs" : "Stuksprijs" ,
    "Totaalprijs" : "Totaalprijs",
    "Dezevindjemisschienookleuk" : "Deze vind je misschien ook leuk",
     "Deelartikel" : "Deel artikel",
     "Geschrevendoor" : "Geschreven door",
     "door" : "door",
     "Laadmeerartikelen" : 'Laad meer artikelen',
     "Bestand(en):" : "Bestand(en):",
     "MiniBestand(en)" : "Bestand(en):",
     "Winkelwagen" : "Winkelwagen",
     "Uw winkelwagen is leeg" : "Uw winkelwagen is leeg.",
     "om naar de homepage te gaan" : "om naar de homepage te gaan",
     "Digitale drukproef" : "Digitale drukproef",
     "Gratis" : "Gratis" ,
     "Instelkosten" : "Instelkosten",
     "Kortingscode" : "Kortingscode",
     "Totaal (excl. BTW)" : "Totaal (excl. BTW)",
     "BTW" : "BTW",
     "Totaalbedrag": "Totaalbedrag",
     "Vrijblijvende offerte" : "Vrijblijvende offerte",
     "Bekijk prijsdetails" : "Bekijk prijsdetails",
     "Verberg prijsdetails" : "Verberg prijsdetails",
     "We hebben voor u gezocht op" : "We hebben voor u gezocht op",
     "wis filters" : "wis filter",
     "Categorieën" : "Categorieën",
     "Sorteren" : "Sorteren",
     "Filters" : "Filters",
     "sorteer op:" : "sorteer op:",
     "artikelen" : "artikelen",
     "filter en sorteer" : "filter en sorteer",
     "Bekijk meer" : "Bekijk meer",
     "Uw zoekopdracht heeft geen resultaten opgeleverd" : "Uw zoekopdracht heeft geen resultaten opgeleverd." ,
    "Hallo, waarmee kunnen we je helpen" : "Hallo, waarmee kunnen we je helpen?",
    "Kan ik een sample ontvangen" : "Kan ik een sample ontvangen?",
    "Wat is de levertijd" : "Wat is de levertijd?",
    "Telefoon" : "Telefoon:",
    "TelefoonBelgie" : "Telefoon België:",
    "E-mail" : "E-mail:",
    "Openingstijden" : "Openingstijden",
    "Deeluwconfiguratiemetuniekelink" : "Deel uw configuratie met unieke link",
    "Toevoegen in favorieten" : "Toevoegen in favorieten",
    "Bewaard in favorieten" : "Bewaard in favorieten",
    "Zie winkelwagen" : "Zie winkelwagen", 
    "Verzendkosten" : "Verzendkosten", 
    "Maatwisselkosten" : "Maatwisselkosten",
    "Prijs per stuk" : "Prijs per stuk",
    "Sample prijs" : "Sample prijs",
    "Verstuurd na" : "Verstuurd na:",
    "Totaal incl. BTW" : "Totaal incl. BTW",
    "Totaal excl. BTW" : "Totaal excl. BTW",
    "Neem contact op" : "Neem contact op",
    "contact_description" : "Heeft u vragen, opmerkingen of suggesties? Laat het ons weten via onderstaand contactformulier. Of neem vrijblijvend contact op via telefoon, e-mail of Whatsapp.",
    "verplicht_veld" : "* verplicht veld",
    "Bezoekadres" : "Bezoekadres",
    "Bedrijfsgegevens" : "Bedrijfsgegevens",
    "Gesloteni.v.m.feestdagen" : "Gesloten i.v.m. feestdagen",
    "KvK nummer:" : "KvK nummer:",
    "BTW nummer:" : "BTW nummer:",
    "Druktechnieken" : "Druktechnieken",
    "Meestgesteldevragen" : "Meest gestelde vragen",
    "Klantenservice" : "Klantenservice",
    "Schrijfalseersteeenreview" : "Schrijf als eerste een review",
    "Vacatures" : "Vacatures" , 
    "Afdeling" : "Afdeling",
    "Bekijken" : "Bekijken",
    "Er zijn momenteel geen vacatures beschikbaar" : "Er zijn momenteel geen vacatures beschikbaar.",
    "Kortingscodes" : "Kortingscodes" ,
    "Korting_desc" : "Een overzicht van kortingscodes en actiecodes bij Promofit vindt uhieronder. De codes zijn eenmalig geldig op een nieuwe onlinebestelling of offerte aanvraag, niet met terugwerkende kracht geldig op lopende bestellingen/aanvragen. Hou deze pagina in de gaten om op de hoogte te blijven van nieuwe actiecodes. Schrijf in voor onze nieuwsbrief of volg ons op onze socials voor meer kortingscodes!",
    "Korting_subdesc" : "De kortingscodes zijn niet van toepassing op BTW, verzendkosten of i.c.m. andere acties, tenzij aangegeven.",
    "Korting" : "Korting" , 
    "Code" : "Code" , 
    "Voorwaarden" : "Voorwaarden",
    "Geldigheid" : "Geldigheid",
    "Actief" : "Actief",
    "Verlopen" : "Verlopen",
    "Kiyohklantbeoordelingen" : "Kiyoh klantbeoordelingen",
    "Inloggen" : "Inloggen" , 
    "Heeft u al een account bij" : "Heeft u al een account bij",
    "Log dan hier in" : "Log dan hier in:",
    "Wachtwoordvergeten" : "Wachtwoord vergeten?",
    "Account_desc" : "Een account aanmaken is niet nodig om te kunnen bestellen, maar is wel handig" ,
    "Nieuwbij" : "Nieuw bij",
    "Maak account aan" : "Maak account aan",
    "forgot_desc" : "Vul hieronder je e-mailadres in. Wij sturen je dan een link zodat je een nieuw wachtwoord kunt instellen. Dit kan even duren, check ook de spam folder.",
    "Jewachtwoordvergeten" : "Je wachtwoord vergeten?",
    "Terug" : "Terug",
    "Account aanmaken" : "Account aanmaken",
    "Hallo" : "Hallo" , 
    "leuk dat je er weer bent" : "leuk dat je er weer bent!" ,
    "Hier vind je de status van je bestellingen" : "Hier vind je de status van je bestellingen", 
    "Address_desc" : "Je kunt ook je wachtwoord aanpassen, adressen toevoegen en nieuwsbriefinschrijving aanpassen.",
    "artikel(en)" : "artikel(en)",
    "Wijzigen" : "Wijzigen",
    "Nieuwsbrief" : "Nieuwsbrief",
    "Mijn gegevens" : "Mijn gegevens",
    "Bedrijfsnaam" : "Bedrijfsnaam",
    "Voornaam" : "Voornaam",
    "Achternaam" : "Achternaam" , 
    "Achternaam*" : "Achternaam *",
    "Telefoonnummer" : "Telefoonnummer",
    "Type klant" : "Type klant",
    "Wachtwoord" : "Wachtwoord",
    "Annuleren" : "Annuleren",
    "Geenselectie" : "No selection",
    "order_question" : "Heeft u vragen over uw bestelling? Stuur dan een e-mail naar",
    "call_us" : "of bel ons op",
    "Via_the_website" : "Via de website",
    "Online_bestelling" : "Online bestelling:",
    "bekijk_details" : "bekijk details",
    "receive_update" : "Ontvang updates van nieuwe producten, aanbiedingen en kortingscodes via onze nieuwsbrief.",
    "subscription" : "Beheer hieronder uw inschrijving. Voor het vakje dat is aangevinkt ontvangt u de nieuwsbrief." ,
    "privacy_policy" : "Lees in ons privacybeleid hoe wij omgaan met uw persoonsgegevens. U kunt zich altijd uitschrijven via de afmeldlink in de nieuwsbrief.",
    "Opslaan" : "Opslaan",
    "Opnieuw_bestellen" : "Opnieuw bestellen",
    "Sample_bestelling" : "Sample bestelling",
    "Offerteaanvraag" : "Offerteaanvraag" , 
    "Betaalmethode" : "Betaalmethode" ,
    "Factuur" : "Factuur" , 
    "Uw gegevens" : "Uw gegevens" ,
    "Factuuradres" : "Factuuradres",
    "Verwachte_verzenddatum" : "Verwachte verzenddatum:",
    "Artikelnummer" : "Artikelnummer",
    "Verberg_details" : "Verberg details" ,
    "Address_desc_overview" : "Adressen die worden gewijzigd, worden helaas nog NIET automatisch doorgevoerd in lopende orders. Geef de adreswijziging dan aub ook door aan de sales medewerker.",
    "Adresboek" : "Adresboek",
    "Standaard factuuradres" : "Standaard factuuradres" ,
    "Er is nog geen standaard factuuradres" : "Er is nog geen standaard factuuradres.",
    "Toevoegen" : "Toevoegen" ,
    "Standaard afleveradres" : "Standaard afleveradres" ,
    "Er is nog geen standaard leveradres" : "Er is nog geen standaard leveradres.",
    "Addnew_address" : "+ Voeg nieuw adres toe",
    "zipcode" : "zipcode",
    "Bekijk_alle_review" : "Bekijk alle review",
    "Solliciteer_direct" : "Solliciteer direct",
    "Deel_deze_vacature" : "Deel deze vacature",
    "terug_naar_vacatures" : "terug naar vacatures",
    "terug naar" : "terug naar",
    "Schrijf_een_review_voor" : "Schrijf een review voor" ,
    "Schrijf_een_review" : "Schrijf een review",
    "Bekijk_alle_reviews" : "Bekijk alle reviews",
    "Review_desc" : "Wij controleren elk ingezonden product review. Na goedkeuring verschijnt uw review op de productpagina.",
    "Sample_bestellen" : "Sample bestellen",
    "Uw_winkelwagen_is_leeg" : "Uw winkelwagen is leeg.",
    "Klik_hier" : "Klik hier",
    "om_naar_de_homepage_te_gaan" : "om naar de homepage te gaan",
    "Vrijblijvende_offerte_aanvraag" : "Vrijblijvende offerte aanvraag",
    "Offerte_aanvragen" : "Offerte aanvragen",
    "Bedankt_voor_je_bestelling" : "Bedankt voor je bestelling",
    "Bedankt_voor_je_offerteaanvraag" : "Bedankt voor je offerteaanvraag",
    "Offertenummer" : "Offertenummer",
    "De_bevestiging_wordt_verstuurd_naar" : "De bevestiging wordt verstuurd naar",
    "Mail_desc" : "Controleer ook de spam folder! Niks ontvangen? Neem contact op via",
    "Bekijk_offerte_in_mijn_account" : "Bekijk offerte in mijn account",
    "verder_winkelen" : "verder winkelen",
    "Vrijblijvende_offerte" : "Vrijblijvende offerte",
    "Ordernummer" : "Ordernummer" ,
    "order_confirm" : "De orderbevestiging wordt verstuurd naar uw e-mailadres.",
    "Bekijk_bestelling_in_mijn_account" : "Bekijk bestelling in mijn account",
    "Besteloverzicht" : "Besteloverzicht",
    "Afrekenen" : "Afrekenen",
    "Naar_verzending" : "Naar verzending",
    "Verzending" : "Verzending",
    "Bestelling_afronden" : "Bestelling afronden",
    "Adres_toevoegen" : "+ Adres toevoegen",
    "Afleveradres" : "Afleveradres",
    "login_with_details_desc" : "U heeft al een account bij ons, log in met uw gegevens.",
    "checkout_desc" : "Let op: bij ophalen wordt het verzendadres niet gebruikt. Uw bestelling kan worden afgehaald op: Pauvreweg 22, 4879 NA Etten-Leur." ,
    "Naar_afronden" : "Naar afronden",
    "Paylater_desc" : "In het geval van bedrukte artikelen ontvangt u de factuur per e-mail na goedkeuring artwork. Bij onbedrukte artikelen ontvangt u de factuur per e-mail na verwerking van de bestelling. Uw bestelling wordt verstuurd nadat de volledige betaling is gedaan.",
    "Mondu_desc" : "Na de levering van uw order ontvangt u de factuur per e-mail en dient u het factuurbedrag binnen 30 dagen te voldoen. Informatie over de verwerking van uw persoonsgegevens door Mondu GmbH vindt u",
    "hier" : "hier",
    "Paylater_lable" : "Bestelling afronden zonder direct te betalen",
    "Huidige_voorraad" : "Huidige voorraad",
    "Geef_de_gewenste_afmeting_op": "Geef de gewenste afmeting op",
    "Faq_placeholder" : "Kan ik een sample/proefmodel ontvangen?",
    "Faq_delivery" : "Wat is de levertijd?" ,
    "Verzonden_op" : "Verzonden op:",
    "mijn-bestellingen" : "mijn-bestellingen",
    "mijn-offertes" : "mijn-offertes",
    "Verwijderen" : "Verwijderen",
    "payment_error" : "Kies een betaalmethode om verder te gaan",
    "Mijn_accountoverzicht" : "My account overview",
    "login" : "Inloggen",
    "Gekopieerd" : "Gekopieerd",
    "Kopieer_link" : "Kopieer link",
    "Populair" : "Populair",
    "Onze keuze!" : "Onze keuze!",
    "Custom made" : "Custom made",
    "van" : "van",
    "en betalingen" : "en betalingen.",
    "per stuk" : "per stuk",
    "bestellingen" : "bestellingen",
    "offerteaanvragen": "offerteaanvragen",
    "stapsgewijze hoeveelheid door" : "stapsgewijze hoeveelheid door",
    "Minimum bestelgrootte" : "Minimum bestelgrootte",
    "Eerst het product testen? Vraag een sample aan!" : "Eerst het product testen? Vraag een sample aan!",
    "Ervaar onze" : "Ervaar onze",
    "snelle topservice!" : "snelle topservice!",
    "High level service" : "High level service",
    "met een vast contact persoon" : "met een vast contact persoon",
    "Laagste prijsgarantie" : "Laagste prijsgarantie",
    "elders goedkoper? Wij matchen!" : "elders goedkoper? Wij matchen!",
    "Beste prijs-kwaliteitverhouding" : "Beste prijs-kwaliteitverhouding",
    "Gratis digitaal voorbeeld" : "Gratis digitaal voorbeeld",
    "binnen enkele uren in uw e-mail!" : "binnen enkele uren in uw e-mail!",
    "Eigen productie" : "Own production",
    "dus snel geleverd" : "dus snel geleverd",
    "Veilig betalen" : "Veilig betalen",
    "o.a. iDeal, Bancontact, ook achteraf!" : "o.a. iDeal, Bancontact, ook achteraf!",
    "searchplaceholder" : "Waar bent u naar op zoek?",
    "op_nacalculatie" : "op nacalculatie *",
    "Totaalprijs bij" : "Totaalprijs bij",
    "incl. BTW" : "incl. BTW",
    "Voornaam*" : "Voornaam *",
    "Bedrijfsnaam*" : "Bedrijfsnaam *",
    "E-mail_adres*" : "E-mail adres *",
    "E-mail_adres" : "E-mail adres",
    "Bevestig_wachtwoord" : "Bevestig wachtwoord",
    "Bevestig_wachtwoord*" : "Bevestig wachtwoord*",
    "Wachtwoord*" : "Wachtwoord *",
    "max_samples_1": "U kunt maximaal",
    "max_samples_2": "samples tegelijk aanvragen, mits beschikbaar.",
    "Huisnummer*" : "Huisnummer *",
    "Onbedrukt_niet_mogelijk" : "Onbedrukt niet mogelijk",
    //use case
    "cartPage_tooltip_quoteMessage" : `Dit artikel is afkomstig uit een offerte; daardoor kunt u het aantal niet direct aanpassen. Wilt u toch graag een ander aantal bestellen? Vraag dan gerust een nieuwe offerte aan.`,
    "address_tooltip_edit_delete" : `Het is op dit moment niet mogelijk om dit adres aan te passen of te verwijderen, omdat het gekoppeld is aan een actieve offerte.`,
    "price_overview": `Prijsoverzicht`
}
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("i18nextLng") || "nl" || navigator.language , 
  fallbackLng: "nl",
  // supportedLngs: ["nl"], 
  interpolation: { escapeValue: false }
});

const observeLanguageChange = () => {
  const observer = new MutationObserver(() => {
    const detectedLang = document.documentElement.lang;
    if (detectedLang && detectedLang !== i18n.language) {
      i18n.changeLanguage(detectedLang);
      localStorage.setItem("i18nextLng", detectedLang);
    }
  });

  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });

  return () => observer.disconnect();
};
observeLanguageChange();

const detectBrowserTranslation = () => {
  // const referenceText = "Welkom";
  const el = document.querySelector("#welcome-text");

  if (el && el.textContent) {
    const currentText = el.textContent.trim();

    if (currentText === "Welcome") {
      // Translated to English
      document.documentElement.setAttribute("lang", "en");
      localStorage.setItem("i18nextLng", "en");
      i18n.changeLanguage("en");
    } else if (currentText === "Welkom") {
      // Back to Dutch
      document.documentElement.setAttribute("lang", "nl");
      localStorage.setItem("i18nextLng", "nl");
      i18n.changeLanguage("nl");
    }
  }
};

const userAgent = navigator.userAgent;
const isEdge = userAgent.includes("Edg/") || userAgent.includes("Edge/");

if (isEdge) {
  const setupObserver = (target) => {
    const observer = new MutationObserver(() => {
      detectBrowserTranslation();
    });

    observer.observe(target, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    detectBrowserTranslation();
  };

  const target = document.querySelector("#welcome-text");

  if (target) {
    setupObserver(target);
  } else {
    const interval = setInterval(() => {
      const el = document.querySelector("#welcome-text");
      if (el) {
        clearInterval(interval);
        setupObserver(el);
      }
    }, 300);
  }
}


export default i18n;
